import { createSelector } from 'reselect';
import moment from 'moment';
import get from 'lodash/get';
import { cloneDeep, orderBy } from 'lodash';

import { SERVICE_INT_DATE_FORMAT } from '@utils/constants';
import { SCOPE } from './types';
import { existingIntSortSelector } from '../base/selectors';

const configStateMap = {
  0: 'Deleted',
  1: 'Disabled',
  2: 'Enabled',
};

const selector = (state) => get(state, SCOPE);
const coreSelector = (state) => get(state, SCOPE).core;
const requestsSelector = (state) => get(state, SCOPE).requests;

export const loadingSelector = createSelector(requestsSelector, (existingIntState) => ({
  loading: existingIntState.isFetching,
  showError: existingIntState.errorCode !== 0,
  errorMsg: existingIntState.errorMsg,
}));

export const dataSelector = createSelector(requestsSelector, (existingIntState) =>
  existingIntState.response ? existingIntState.response.data : {},
);

export const existingIntDataSortSelector = createSelector(
  existingIntSortSelector,
  dataSelector,
  (sortInfo, tableData) => {
    const records = [];

    get(tableData, 'data', []).forEach((row) => {
      const rowData = cloneDeep(row);
      const updatedDate = moment(row.updatedAt).format(SERVICE_INT_DATE_FORMAT);

      rowData.updatedAt = updatedDate;

      // Remove deleted row
      if (rowData.state !== 0) {
        rowData.status = configStateMap[rowData.state];
        records.push(rowData);
      }
    });

    const orderedRecords = orderBy(records, [sortInfo.key], [sortInfo.order]);

    return {
      data: orderedRecords,
      sort: sortInfo,
    };
  },
);

export const actionSelector = createSelector(coreSelector, (state) => state.action);

export const warningModalVisibilitySelector = createSelector(
  coreSelector,
  (state) => state.isWarningModalVisible,
);

export default selector;
